import { Link } from 'react-router-dom';
import type { BlogArticle } from '@/mocks/blogData';

interface BlogRelatedArticlesProps {
  articles: BlogArticle[];
}

export default function BlogRelatedArticles({ articles }: BlogRelatedArticlesProps) {
  if (articles.length === 0) return null;

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-10">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-4 font-label">
            RELATED
          </p>
          <h2 className="font-heading text-lg md:text-xl text-foreground-900 tracking-[0.06em] mb-3">
            関連記事
          </h2>
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="card-glow bg-background-50 border border-background-200/60 p-5 group cursor-pointer"
            >
              <span className="text-[12px] tracking-[0.08em] text-accent-600 bg-accent-100/70 px-2 py-0.5 whitespace-nowrap mb-2 inline-block">
                {article.category}
              </span>
              <h4 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-2 group-hover:text-accent-600 transition-colors duration-300 line-clamp-2">
                {article.title}
              </h4>
              <p className="text-[14px] text-foreground-500 tracking-[0.04em]">{article.date}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}